// 国家与地区关键词库，用于国际热点识别与国旗展示。
// 这里优先覆盖微博热搜中高频出现的中文名、简称、英文名与常见别称。

export interface Country {
  name: string;
  aliases: string[];
  flag: string;
  region: "亚洲" | "欧洲" | "北美洲" | "南美洲" | "大洋洲" | "非洲" | "其他";
}

export const COUNTRIES: Country[] = [
  { name: "中国", aliases: ["中华人民共和国", "China", "PRC", "内地", "大陆"], flag: "🇨🇳", region: "亚洲" },
  { name: "美国", aliases: ["美方", "美国政府", "United States", "USA", "US", "America"], flag: "🇺🇸", region: "北美洲" },
  { name: "加拿大", aliases: ["Canada", "加国"], flag: "🇨🇦", region: "北美洲" },
  { name: "墨西哥", aliases: ["Mexico"], flag: "🇲🇽", region: "北美洲" },
  { name: "巴西", aliases: ["Brazil"], flag: "🇧🇷", region: "南美洲" },
  { name: "阿根廷", aliases: ["Argentina"], flag: "🇦🇷", region: "南美洲" },
  { name: "智利", aliases: ["Chile"], flag: "🇨🇱", region: "南美洲" },
  { name: "秘鲁", aliases: ["Peru"], flag: "🇵🇪", region: "南美洲" },
  { name: "哥伦比亚", aliases: ["Colombia"], flag: "🇨🇴", region: "南美洲" },
  { name: "英国", aliases: ["英方", "英政府", "United Kingdom", "UK", "Britain", "大英"], flag: "🇬🇧", region: "欧洲" },
  { name: "法国", aliases: ["法方", "France"], flag: "🇫🇷", region: "欧洲" },
  { name: "德国", aliases: ["德方", "Germany"], flag: "🇩🇪", region: "欧洲" },
  { name: "意大利", aliases: ["Italy"], flag: "🇮🇹", region: "欧洲" },
  { name: "西班牙", aliases: ["Spain"], flag: "🇪🇸", region: "欧洲" },
  { name: "葡萄牙", aliases: ["Portugal"], flag: "🇵🇹", region: "欧洲" },
  { name: "荷兰", aliases: ["Netherlands", "Holland"], flag: "🇳🇱", region: "欧洲" },
  { name: "比利时", aliases: ["Belgium"], flag: "🇧🇪", region: "欧洲" },
  { name: "瑞士", aliases: ["Switzerland"], flag: "🇨🇭", region: "欧洲" },
  { name: "奥地利", aliases: ["Austria"], flag: "🇦🇹", region: "欧洲" },
  { name: "瑞典", aliases: ["Sweden"], flag: "🇸🇪", region: "欧洲" },
  { name: "挪威", aliases: ["Norway"], flag: "🇳🇴", region: "欧洲" },
  { name: "丹麦", aliases: ["Denmark"], flag: "🇩🇰", region: "欧洲" },
  { name: "芬兰", aliases: ["Finland"], flag: "🇫🇮", region: "欧洲" },
  { name: "波兰", aliases: ["Poland"], flag: "🇵🇱", region: "欧洲" },
  { name: "捷克", aliases: ["Czech Republic", "Czechia"], flag: "🇨🇿", region: "欧洲" },
  { name: "希腊", aliases: ["Greece"], flag: "🇬🇷", region: "欧洲" },
  { name: "爱尔兰", aliases: ["Ireland"], flag: "🇮🇪", region: "欧洲" },
  { name: "冰岛", aliases: ["Iceland"], flag: "🇮🇸", region: "欧洲" },
  { name: "俄罗斯", aliases: ["俄方", "俄国", "Russia"], flag: "🇷🇺", region: "欧洲" },
  { name: "乌克兰", aliases: ["乌方", "Ukraine"], flag: "🇺🇦", region: "欧洲" },
  { name: "白俄罗斯", aliases: ["Belarus"], flag: "🇧🇾", region: "欧洲" },
  { name: "土耳其", aliases: ["Turkey", "Türkiye"], flag: "🇹🇷", region: "亚洲" },
  { name: "日本", aliases: ["日方", "Japan", "霓虹"], flag: "🇯🇵", region: "亚洲" },
  { name: "韩国", aliases: ["韩方", "South Korea", "Korea"], flag: "🇰🇷", region: "亚洲" },
  { name: "朝鲜", aliases: ["North Korea", "DPRK"], flag: "🇰🇵", region: "亚洲" },
  { name: "蒙古", aliases: ["Mongolia"], flag: "🇲🇳", region: "亚洲" },
  { name: "越南", aliases: ["Vietnam"], flag: "🇻🇳", region: "亚洲" },
  { name: "泰国", aliases: ["Thailand"], flag: "🇹🇭", region: "亚洲" },
  { name: "新加坡", aliases: ["Singapore", "狮城", "星洲"], flag: "🇸🇬", region: "亚洲" },
  { name: "马来西亚", aliases: ["Malaysia", "大马"], flag: "🇲🇾", region: "亚洲" },
  { name: "印度尼西亚", aliases: ["印尼", "Indonesia"], flag: "🇮🇩", region: "亚洲" },
  { name: "菲律宾", aliases: ["Philippines"], flag: "🇵🇭", region: "亚洲" },
  { name: "印度", aliases: ["India"], flag: "🇮🇳", region: "亚洲" },
  { name: "巴基斯坦", aliases: ["Pakistan"], flag: "🇵🇰", region: "亚洲" },
  { name: "孟加拉国", aliases: ["孟加拉", "Bangladesh"], flag: "🇧🇩", region: "亚洲" },
  { name: "斯里兰卡", aliases: ["Sri Lanka"], flag: "🇱🇰", region: "亚洲" },
  { name: "尼泊尔", aliases: ["Nepal"], flag: "🇳🇵", region: "亚洲" },
  { name: "哈萨克斯坦", aliases: ["Kazakhstan"], flag: "🇰🇿", region: "亚洲" },
  { name: "乌兹别克斯坦", aliases: ["Uzbekistan"], flag: "🇺🇿", region: "亚洲" },
  { name: "伊朗", aliases: ["Iran"], flag: "🇮🇷", region: "亚洲" },
  { name: "伊拉克", aliases: ["Iraq"], flag: "🇮🇶", region: "亚洲" },
  { name: "以色列", aliases: ["Israel"], flag: "🇮🇱", region: "亚洲" },
  { name: "巴勒斯坦", aliases: ["Palestine"], flag: "🇵🇸", region: "亚洲" },
  { name: "沙特阿拉伯", aliases: ["沙特", "Saudi Arabia"], flag: "🇸🇦", region: "亚洲" },
  { name: "阿联酋", aliases: ["阿拉伯联合酋长国", "UAE", "United Arab Emirates"], flag: "🇦🇪", region: "亚洲" },
  { name: "卡塔尔", aliases: ["Qatar"], flag: "🇶🇦", region: "亚洲" },
  { name: "科威特", aliases: ["Kuwait"], flag: "🇰🇼", region: "亚洲" },
  { name: "埃及", aliases: ["Egypt"], flag: "🇪🇬", region: "非洲" },
  { name: "南非", aliases: ["South Africa"], flag: "🇿🇦", region: "非洲" },
  { name: "尼日利亚", aliases: ["Nigeria"], flag: "🇳🇬", region: "非洲" },
  { name: "肯尼亚", aliases: ["Kenya"], flag: "🇰🇪", region: "非洲" },
  { name: "摩洛哥", aliases: ["Morocco"], flag: "🇲🇦", region: "非洲" },
  { name: "阿尔及利亚", aliases: ["Algeria"], flag: "🇩🇿", region: "非洲" },
  { name: "澳大利亚", aliases: ["澳洲", "Australia"], flag: "🇦🇺", region: "大洋洲" },
  { name: "新西兰", aliases: ["New Zealand"], flag: "🇳🇿", region: "大洋洲" },
  { name: "斐济", aliases: ["Fiji"], flag: "🇫🇯", region: "大洋洲" },
];

export const COUNTRY_MAP: Map<string, Country> = new Map();

COUNTRIES.forEach((country) => {
  COUNTRY_MAP.set(country.name, country);
  country.aliases.forEach((alias) => {
    COUNTRY_MAP.set(alias, country);
  });
});

export function getAllCountryNames(): string[] {
  const names: string[] = [];
  COUNTRIES.forEach((country) => {
    names.push(country.name);
    names.push(...country.aliases);
  });
  return names;
}

export function extractCountriesFromText(text: string): Country[] {
  const foundCountries = new Set<Country>();
  const sortedNames = getAllCountryNames().sort((a, b) => b.length - a.length);

  for (const name of sortedNames) {
    if (text.includes(name)) {
      const country = COUNTRY_MAP.get(name);
      if (country) {
        foundCountries.add(country);
      }
    }
  }

  return Array.from(foundCountries);
}

export function getCountryByName(name: string): Country | undefined {
  return COUNTRY_MAP.get(name);
}
